<template>
    <div id="merge-property-modal"
         class="modal fade"
         tabindex="-1"
         role="dialog"
         style="display: none;">

        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title font-medium" id="modalTitle">Merge Property</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                </div>
                <div class="modal-body p-4">
                    <form class="form">
                        <div class="form-group mt-3">
                            <h5 class="text-center text-base font-normal mb-3">Merge {{ asset.name }}
                                <span v-if="asset.external_source && !hasFeature('release_new_asset_list')" class="text-muted"> ({{ asset.external_source }})</span>
                                <span v-else-if="asset.external_source" class="text-muted"> ({{ asset.external_source.integration_alias }})</span>
                                into
                            </h5>

                            <div class="col-sm-12">
                                <remote-select
                                    v-model="form.selectedAsset"
                                    @focus="searchAssets"
                                    :remote-method="searchAssets"
                                    :loading="loading"
                                    :data="assets"
                                    item-label="name"
                                    placeholder="Start typing to search assets, addresses or linked contacts">
                                    <template slot-scope="props">
                                        <assets-drop-down-item :asset="props.item"></assets-drop-down-item>
                                    </template>
                                </remote-select>
                            </div>

                            <div class="form-group col-sm-12">
                                <div class="mt-8 bg-red-100 p-4 rounded text-brand">
                                    NOTE: All <b>inspections</b>, <b>tickets</b> & <b>contacts</b> of {{ asset.name }}
                                    will be moved to the destination property you selected.
                                </div>
                            </div>

                            <div class="form-group col-sm-12">
                                <div class="mt-2 bg-red-100 p-4 rounded text-brand">
                                    NOTE: All <b>to-dos</b> of {{ asset.name }} will be archived.
                                </div>
                            </div>

                            <div class="form-group col-sm-12 mt-8">
                                <checkbox v-model="form.archive" class="gap-2">Archive empty property after merge</checkbox>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer px-6 py-4">
                    <button
                        class="select-none sm:ml-2 px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow text-white bg-indigo-600 hover:bg-indigo-700"
                        @click.prevent="mergeIntoOtherAsset"
                        :disabled="form.busy">Merge
                    </button>

                    <button
                        type="button"
                        class="select-none sm:ml-2 px-4 py-2 border border-gray-300 text-gray-700 shadow-sm hover:text-gray-500 text-sm font-medium rounded-md shadow text-white hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:ring focus:ring-blue-400 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                        data-dismiss="modal"
                        :disabled="form.busy">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import AssetSearch from "../../mixins/asset-search";

export default {
    name: "merge-property-modal",
    mixins: [AssetSearch],
    props: ["asset"],

    data () {
        return {
            form: new AppForm({
                "archive": false
            })
        };
    },

    methods: {
        mergeIntoOtherAsset () {
            if (this.form.selectedAsset) {
                this.$set(this.form, "selectedAsset", this.form.selectedAsset.id);
            }
            App.post("/assets/" + this.asset.id + "/merge", this.form)
            .then(() => {
                toastr.success("Asset merged successfully");
                this.$emit("asset-merged");
            }).catch(() => {
                toastr.error("Could not merge asset!");
            });
        }
    }

};
</script>

<style scoped>

</style>
